module.exports = __webpack_public_path__ + "img/HN.dc52213f.png";